// file: paymentSummary.jsx
import React, { useState } from "react";
import styles from "./paymentSummary.module.scss";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import OutlinedButton from "../../customComponents/outlinedButton/OutlinedButton";
import PaymentCard from "../paymentCard/PaymentCard";
import { Dialog } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchPayment } from "../../../store/actions";
import PdfDownload from "../../customComponents/pdfDownload/PdfDownload";

const PaymentSummary = ({ calculation, cartBundleId }) => {
  const dispatch = useDispatch();
  const paymentDetails = useSelector(
    (state) => state?.razorpay?.paymentDetails
  );
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);

  const getPaymentDetails = () => {
    console.log("calculation?.paymentId ", calculation?.paymentId);
    dispatch(
      fetchPayment({
        paymentId: calculation?.paymentId,
        callback: { success: () => setShow(true) },
      })
    );
  };

  const handleCopyPaymentId = () => {
    if (!calculation?.paymentId) return;

    navigator.clipboard.writeText(calculation?.paymentId).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {/* Top Row */}
        <div className={styles.top}>
          <div className={styles.left}>
            <div className={styles.paymentStatus}>
              <div className={styles.iconBox}>
                <CreditCardOutlinedIcon />
              </div>
              <span className={styles.paymentText}>Payment</span>
              <span className={styles.statusBadge}>Paid</span>

              <div className={styles.invoiceButton}>
                <PdfDownload orderDetails={cartBundleId} />
              </div>
            </div>

            <div className={styles.transactionBox}>
              <div
                className={styles.transactionIcon}
                onClick={handleCopyPaymentId}
              >
                {copied ? (
                  <CheckOutlinedIcon color="success" />
                ) : (
                  <ContentCopyOutlinedIcon />
                )}
              </div>
              <div
                className={styles.transactionDetails}
                onClick={() => getPaymentDetails()}
              >
                <span className={styles.transactionLabel}>Razor Pay ID</span>
                <span className={styles.transactionId}>
                  {calculation?.paymentId}
                </span>
              </div>
            </div>
          </div>

          <div className={styles.right}></div>
        </div>

        {/* Price Breakdown */}
        <div className={styles.middle}>
          <div className={styles.row}>
            <span className={styles.label}>Subtotal</span>
            <span className={styles.value}>
              ₹
              {Number(calculation?.grandTotal) - Number(calculation?.gstAmount)}
            </span>
          </div>

          <div className={styles.row}>
            <span className={styles.label}>Shipping</span>
            <span className={styles.value}>₹{calculation?.deliveryCharge}</span>
          </div>

          <div className={styles.row}>
            <span className={styles.label}>GST</span>
            <span className={styles.value}>₹{calculation?.gstAmount || 0}</span>
          </div>
        </div>

        <hr className={styles.divider} />

        {/* Grand Total */}
        <div className={styles.bottom}>
          <span className={styles.totalLabel}>Grand Total</span>
          <span className={styles.totalValue}>
            ₹
            {Number(calculation?.grandTotal) +
              Number(calculation?.deliveryCharge)}
          </span>
        </div>
      </div>

      {/* Payment Details Dialog */}
      <Dialog
        open={show}
        onClose={() => setShow(false)}
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
      >
        <PaymentCard
          paymentDetails={paymentDetails}
          calculation={calculation}
        />
      </Dialog>
    </div>
  );
};

export default PaymentSummary;
